export const API_VERSION = 'v1';
/** Max size of a single `yjs_update.update` string (base64 ciphertext). */
export const MAX_YJS_UPDATE_BYTES = 256 * 1024;
/**
 * Max size of a `yjs_sync_response.update` envelope (base64 ciphertext).
 * Larger than `MAX_YJS_UPDATE_BYTES` because a response carries a full Y.Doc
 * snapshot diff, not an incremental update. 2 MB covers realistic single-page
 * docs; oversize responses are silently dropped at the responder and the
 * change_event re-merge path (driven by the next snapshot PUT) catches up.
 */
export const MAX_YJS_SYNC_RESPONSE_BYTES = 2 * 1024 * 1024;
/**
 * Time bound on the `pullAll` clobber-guard: a `pendingSync: true` local row
 * older than this yields to the server's row instead of being protected from
 * overwrite indefinitely. Combined with the infinite-retry snapshot loop
 * (every legitimate write either lands or surfaces a permanent error within
 * a few retries), this prevents a stuck row from staying immortal across
 * sessions. 60 s is conservative: the retry backoff caps at 30 s, so any
 * pending write older than this either succeeded or already announced a
 * permanent failure to the user.
 */
export const STALE_PENDING_MS = 60_000;
// --------------------------------------------------------------------------
// Security constants
// --------------------------------------------------------------------------
export const AUTO_LOCK_DEFAULT_MS = 15 * 60 * 1000;
export const MAX_LOGIN_ATTEMPTS = 5;
/**
 * Consecutive TOTP-only failures (password was correct) that trigger the
 * account lock. Tighter than the overall MAX_LOGIN_ATTEMPTS because a
 * password-correct / TOTP-wrong pattern is a strong signal of a stolen
 * password being probed for the 2nd factor.
 */
export const MAX_TOTP_FAILURES_BEFORE_LOCK = 3;
/**
 * Rolling 24-hour ceiling on TOTP failures per user. Once exceeded, TOTP
 * verification is refused even for a correct code until admin runs
 * `reset-2fa` or the window elapses — prevents a patient distributed
 * attacker from guessing 6-digit codes across many lockout cycles.
 */
export const MAX_TOTP_FAILURES_PER_DAY = 10;
export const TOTP_FAILURE_WINDOW_MS = 24 * 60 * 60 * 1000;
/**
 * Per-user cap on new-IP verification emails within a 1-hour rolling
 * window. Over the cap we silently skip the send (the caller still sees
 * `ip_challenge` so the rate is undetectable) — prevents mailbox-bombing
 * a user via coordinated sign-in attempts from many IPs.
 */
export const MAX_IP_CHALLENGES_PER_HOUR = 5;
export const IP_CHALLENGE_WINDOW_MS = 60 * 60 * 1000;
export const ACCOUNT_LOCK_MS = 60 * 60 * 1000;
export const IP_BAN_MS = 24 * 60 * 60 * 1000;
//# sourceMappingURL=index.js.map